<template>
  <div class="serviceDetail">
    <div class="detailTop">
      <div class="title">
        {{ info.title }}
        <span class="back" @click="goBack">&lt;&lt;&nbsp;返回</span>
      </div>
      <div class="line"></div>
      <div class="content" v-html="info.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceDetail",
  props: ["id"],
  data() {
    return {
      imgLeft: 0,
      mainImg: "",
      imgInterval: "",
      info: [],
      imgLen: 0,
      imgIndex: 0,
    };
  },
  created() {
    let id = this.$route.params.id - 1;
    this.getarticleshow();
  },
  mounted() {},
  beforeDestroy() { },
  methods: {
      getarticleshow() {
          let self = this;
          var url = "index/article_show?article_id="+this.$route.params.id;
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.info = res.data.data.info.detail;
          })
      },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.serviceDetail {
  width: 120rem;
  margin: 0 auto;

  .detailTop {
    padding: 5rem 0;

    .title {
      text-align: center;
      font-size: 4.6rem;
      font-weight: 300;
      position: relative;

      .back {
        font-size: 1.6rem;
        color: #3d8bed;
        cursor: pointer;
        position: absolute;
        left: 1rem;
        top: 2rem;
      }
    }

    .line {
      width: 20rem;
      height: 0.4rem;
      background-color: #6366eb;
      margin: 2rem auto;
    }

    .content {
      text-align: left;
      font-size: 1.8rem;
      font-weight: 400;
      line-height: 1.8;
      white-space: pre-wrap;
    }
  }

  .imgList {
    width: 100%;

    .mainImg {
      width: 100%;
      margin-bottom: 3rem;
      height: 48rem;
      overflow: hidden;

      img {
        /*width: 60%;
        margin-left: 20%;*/
        max-width: 100%;
      }
    }

    .tabs {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;

      .leftArrow {
        width: 6rem;
        cursor: pointer;
        padding-top: 7rem;
        margin-right: 1rem;
        transition: all 0.5s linear;
        text-align: center;
      }

      .leftArrow:hover {
        transition: 0.5s;
        background-color: #eee;
      }

      .imgContainer {
        height: 16rem;

        .imgs {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          transition: all 1s ease-in-out;

          .imgItem {
            width: 15rem;
            height: 15rem;
            padding: 0.5rem;
            background-color: #e3e8eb;
            border-radius: 0.5rem;
            margin-right: 2rem;
            cursor: pointer;

            .box {
              overflow: hidden;

              img {
                width: 15rem;
                height: 15rem;
                transition: all 0.8s ease;
              }

              img:hover {
                transition: 0.8s;
                transform: scale(1.1);
              }
            }
          }
        }
      }

      .rightArrow {
        width: 6rem;
        cursor: pointer;
        padding-top: 7rem;
        margin-left: 1rem;
        transition: all 0.5s linear;
        text-align: center;
      }

      .rightArrow:hover {
        transition: 0.5s;
        background-color: #eee;
      }
    }
  }

  .serviceInformation {
    .infoTitle {
      padding-left: 1rem;
      font-size: 3rem;
      font-weight: 500;
      border-left: 0.6rem solid #008ed3;
      text-align: left;
      height: 3.2rem;
      line-height: 3.2rem;
      margin: 4rem 0;
    }

    .infoContent {
      font-size: 1.8rem;
      font-weight: 400;
      text-align: left;
      line-height: 1.8;
      margin-bottom: 4rem;
    }

    .infoContent1 {
      ul {
        margin: 0;
        padding: 0;
        margin-left: 2rem;
        margin-bottom: 4rem;

        li {
          text-align: left;
          font-size: 1.8rem;
          line-height: 1.8;

          .conTitle {
            font-weight: 600;
          }
          .conContent{
            white-space: pre-wrap;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .serviceDetail{
      width: 80%;
      margin: 0 auto;
    .detailTop{
      .title{
        font-size: 10rem;
      }
      .content{
        font-size: 10rem !important;
      }
    }


      .serviceInformation {
          .infoTitle{
              font-size: 7rem;
              height: 5.2rem;
              line-height: 4.2rem;
          }

          .infoContent {
              font-size: 1.8rem;
              font-weight: 400;
              text-align: left;
              line-height: 1.8;
              margin-bottom: 4rem;
          }

          .infoContent1 {
              ul {
                  margin: 0;
                  padding: 0;
                  margin-left: 2rem;
                  margin-bottom: 4rem;

                  li {
                      text-align: left;
                      font-size: 1.8rem;
                      line-height: 1.8;

                      .conTitle {
                          font-weight: 600;
                      }
                      .conContent{
                          white-space: pre-wrap;
                      }
                  }
              }
          }
      }
  }
}

</style>
<style lang="scss">
.productDetail {
  .el-icon-arrow-left:before {
    font-size: 2rem;
    font-weight: 800;
    color: black;
  }

  .el-icon-arrow-right:before {
    font-size: 2rem;
    font-weight: 800;
    color: black;
  }
}
</style>
